require('./brokerWarrantsBuyStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ components
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { LoadingSection } = require('commonsComponents/loadingSection');
const ExantCostBuyWarrants = require('components/broker/brokerWarrantsBuy/brokerWarrantsBuyStep2/components/exantCostWarrant.js')

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const WebappRender = require('components/conditionalRender/webappRender')

const { BROKER_STOCKS_BUY_ID } = require('constants/operationTypes');

const {
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    CHARGE_ACCOUNT_PREFIX,
    CONTENT_TYPE_PDF,
    FIRST_STEP,
    SECOND_STEP,
    TYPE_WARRANTS,
    BROKER_PRODUCT_TYPE_LEGAL_WARRANTS
} = require('constants/index');

class BrokerWarrantsBuyStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.handleTermsChecked = this.handleTermsChecked.bind(this);
        this.handleWarningOperationChecked = this.handleWarningOperationChecked.bind(this);
        this.handleDisclaimerClick = this.handleDisclaimerClick.bind(this);
        this.handleDownloadDFIDocument = this.handleDownloadDFIDocument.bind(this);
    }

    componentWillMount(){
        const {warrantTransactionCost, fundIsin, immFeatureFlags} = this.props;
        const showExantCostBuyWarrants = immFeatureFlags.get('wealth_warrants_buy_show_costs');
        if (!showExantCostBuyWarrants) {
            warrantTransactionCost(fundIsin);
        }
    }

    handleDisclaimerClick() {
        const dataBlock = this.props.immBrokerWarrantsBuy.get('WarrantsTransactionCostBase64Data');
        const dataID = this.props.immBrokerWarrantsBuy.get('WarrantsTransactionCostObjectId');
        const base64String = `data:${CONTENT_TYPE_PDF};base64,${dataBlock}`;
        if (!__CONTACT_CENTER__) {
            downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, dataID);
        } else {
            let pdfWindow = window.open("")
            pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(dataBlock) + "'></iframe>");
        }
    }

    handleDownloadDFIDocument() {
        this.props.onDownloadDFIDocument(this.props.fundIsin, this.props.history);
    }

    handleTermsChecked(e) {
        this.props.handleChangeReadChecked(e.target.checked);
    }

    handleWarningOperationChecked(){
        this.props.handleChangeWarningOperationChecked();
    }

    render() {
        const {
            productFile,
            immBrokerWarrantsBuy,
            immStocksContracts,
            fundIsin,
            setDocumentsRead,
            immFeatureFlags,
            fetchExtantCostWarrantsBuy,
        } = this.props;
        const showExantCostBuyWarrants = immFeatureFlags.get('wealth_warrants_buy_show_costs');
        const step1 = immBrokerWarrantsBuy.get('steps').get(FIRST_STEP);
        const stocksContractSelectedValue = immBrokerWarrantsBuy.getIn(['steps', FIRST_STEP, 'stocksContractSelectedValue']);
        const stockContract = immStocksContracts.get(stocksContractSelectedValue);
        const operative = formatText('operatives-SimplePurchaseofWarrants');
        const checkboxLabel = formatText('broker-warrantDisclaimer1');
        const checkedWarningOperation = immBrokerWarrantsBuy.getIn(['steps', SECOND_STEP, 'checkedWarning']);
        const checked = immBrokerWarrantsBuy.getIn(['steps', SECOND_STEP, 'checked']);
        const checkedIsValid = immBrokerWarrantsBuy.getIn(['steps', SECOND_STEP, 'checkedIsValid']);
        const checkedWarningIsValid = immBrokerWarrantsBuy.getIn(['steps', SECOND_STEP, 'checkedWarningIsValid']);
        const showWarning = immBrokerWarrantsBuy.getIn(['steps', SECOND_STEP, 'showWarning']);
        const productCurrency = productFile.get('currencyCode');
        const companyName = productFile.get('companyName');
        const contractNumber = stockContract.get('walletNumber');
        const productNumber = stockContract.get('productNumber');
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const titlesAmount = immBrokerWarrantsBuy.get("confirmationData").titulosImporteAproximado;
        if (immBrokerWarrantsBuy.get('isFetching')) {
            return <LoadingSection/>
        }
        const operationParams = {
            bondsNumber: titlesAmount,
            chargeAccount: chargeAccount
        };
        const okLink = showExantCostBuyWarrants ? (
            <div>
                <FormattedText value="brokerWarrantBuy-warrantExantCostsDisclaimer" />
            </div>
        ) : (
            <div>
                {checkboxLabel}
                <FormattedText value="broker-warrantDisclaimer2" />
                <FormattedText value="broker-warrantDisclaimer5" />
                <FormattedText value="broker-warrantDisclaimer6" />
                <FormattedText value="broker-warrantDisclaimer7" />
            </div>
        );
        const okLinkWarningOperation = formatText('broker-warrantsBuyStep2WarningOperationDisclaimer');

        let documentsNotRead = null;
        if (showWarning) {
            documentsNotRead = (
                <div className="warrants-buy-step2__warning-message">
                    <OKMessage type="warning">
                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                    </OKMessage>
                </div>
            );
        }
        const signatureSection = __CONTACT_CENTER__ || (checked && checkedWarningOperation) ? (
            <SignaturePattern
                operationType={BROKER_STOCKS_BUY_ID}
                operationParams={operationParams}
            />
        ) : null;

        return (
            <div className="warrants-buy-step2">
                <header className="warrants-buy-step2__header">
                    <h2 className="warrants-buy-step2__header-title">
                        <FormattedText value="broker-warrantsBuyStep2HeaderTitle" />
                    </h2>
                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>
                    <p className="warrants-buy-step2__header-info">
                        <FormattedText value="broker-warrantsBuyStep2HeaderText" />
                    </p>
                </header>
                {showExantCostBuyWarrants ? (
                    <section className="warrants-buy-step2__section">
                        <ExantCostBuyWarrants
                            productCurrency={productCurrency}
                            productIso={productFile.get("micCode")}
                            productType={TYPE_WARRANTS}
                            stockContract={stockContract}
                            stockDescription={productFile.get("companyName")}
                            step1={step1}
                            fetchExtantCostWarrantsBuy={fetchExtantCostWarrantsBuy}
                            immWarrantBuy={immBrokerWarrantsBuy}
                        />
                    </section>
                ) : (
                    <section className="warrants-buy-step2__section">
                        <h2 className="warrants-buy-step2__section-title">
                            <FormattedText value="broker-warrantsBuyStep2Subtitle" />
                        </h2>
                        <StocksBuySellSummary
                            productName={formatText('broker-warrantProductName')}
                            productCurrency={productCurrency}
                            stockContract={stockContract}
                            stockDescription={productFile.get('companyName')}
                            step1={step1}
                            modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER}
                            maskLimitOrderType={true}
                            productType={TYPE_WARRANTS}
                        />
                    </section>
                )}
                <footer className="warrants-buy-step2__section">
                    <WebappRender>
                        <BrokerLegalDocumentation
                            isin={fundIsin}
                            productDefinition={companyName}
                            productType={BROKER_PRODUCT_TYPE_LEGAL_WARRANTS}
                            reportCompleted={() => setDocumentsRead()}
                            enableTransactionCost={!showExantCostBuyWarrants}
                        />
                        {documentsNotRead}
                        <div className="warrants-buy-step2__checkbox">
                            <OKCheckbox
                                idName="okdiscounts__add-discount-acceptance-checkbox"
                                label={okLink}
                                value={checked}
                                onChange={this.handleTermsChecked}
                                errorState={!checkedIsValid}
                                errorMessage={formatText('broker-checkError')}
                            />
                        </div>
                        <div className="warrants-buy-step2__checkbox">
                            <OKCheckbox
                                idName="okdiscounts__add-discount-acceptance-checkbox2"
                                label={okLinkWarningOperation}
                                value={checkedWarningOperation}
                                onChange={this.handleWarningOperationChecked}
                                disabled={!checked}
                                errorState={!checkedWarningIsValid}
                                errorMessage={formatText('broker-checkError')}
                            />
                        </div>
                    </WebappRender>
                    <section className="warrant-buy-step2__signature-pattern-section">
                        <ContactCenterRender>
                            <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                        </ContactCenterRender>
                        {signatureSection}
                    </section>
                </footer>
            </div>
        );
    }

}

BrokerWarrantsBuyStep2.propTypes = {
    productFile: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerWarrantsBuy: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    handleChangeReadChecked: PropTypes.func.isRequired,
    handleChangeWarningOperationChecked: PropTypes.func.isRequired,
    warrantTransactionCost: PropTypes.func.isRequired,
    fundIsin: PropTypes.string.isRequired,
    onDownloadDFIDocument: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    immFeatureFlags: PropTypes.object.isRequired,
    fetchExtantCostWarrantsBuy: PropTypes.func.isRequired,
};

module.exports = withRouter(BrokerWarrantsBuyStep2);
